import React from 'react';
import { stateToColor } from '../../../../constants/styling/styles';
import { showState } from '../../../../selectors/events/timetable';
import { msToTime, isZero, isUnlimited } from '../../../../lib/date.utils';

const DetailsClearance = ({ live, nonLinear, useUntil }) => (
    <React.Fragment>
        {showState(live) || showState(nonLinear) ? <p className="ckp-entry-details-label">Clearance Status</p> : null}
        <div className="ckp-entry-details-field">
            {showState(live) ? (
                <p className={`ckp-entry-details-status is-${stateToColor(live)}`}>
                    Live: <span className="u-uppercase">{(live || '').replace(/_/g, ' ')}</span>
                </p>
            ) : null}
            {showState(nonLinear) ? (
                <p className={`ckp-entry-details-status is-${stateToColor(nonLinear)}`}>
                    <span className="u-inline-block">
                        Non Linear: <span className="u-uppercase">{(nonLinear || '').replace(/_/g, ' ')}</span>
                    </span>
                    <span className="ckp-entry-details-status-field u-inline-block">
                        {useUntil && !isZero(useUntil)
                            ? `Until: ${isUnlimited(useUntil) ? 'Unlimited' : msToTime(useUntil)}`
                            : ''}
                    </span>
                </p>
            ) : null}
        </div>
    </React.Fragment>
);

export default DetailsClearance;



// WEBPACK FOOTER //
// ./src/components/application/timetable/entries/DetailsClearance.js